import { Box, Flex, Grid } from '@chakra-ui/react';
import { Color } from 'src/theme/color';

export const FormSectionAddon = ({ children }: { children: React.ReactNode }) => {
	return (
		<Flex
			flexDir="column"
			mt="40px"
			gap="10px"
		>
			<Box
				w="18px"
				h="1px"
				bg="white"
			/>
			<Flex
				flexDir="column"
				fontSize="14px"
				gap="10px"
				color={Color.GRAY_1}
			>
				{children}
			</Flex>
		</Flex>
	);
};
